import * as React from "react";
import { UnmountClosed } from "react-collapse";

interface ITableExpandProps {
    length: number;
    children: any;
}

export const TableExpand = (props: ITableExpandProps) => {
    return (
        <tr className="te-subrow" key={`expand-content`}>
            <td colSpan={props.length} className="pl-0 pr-0 pt-0 pb-0">
                <UnmountClosed isOpened={true}>{props.children}</UnmountClosed>
            </td>
        </tr>
    );
};
